import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WebSocketService } from '@core/websocket';
import { SessionService } from '@core/services/session.service';
import { ApprovalNotificationService } from '@features/cabinet/approval-notification.service';
import { ApprovalNotificationComponent } from '@shared/components/approval-notification/approval-notification.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ApprovalNotificationComponent],
  template: `
    <router-outlet />
    <app-approval-notification />
  `,
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:beforeunload)': 'onBeforeUnload()',
  },
})
export class App {
  private readonly sessionService = inject(SessionService);
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    inject(WebSocketService).connect();
    inject(ApprovalNotificationService);
    this.iconRegistry.registerFontClassAlias('symbols', 'material-symbols-outlined');
  }

  onBeforeUnload(): void {
    const sessionId = this.sessionService.sessionId();
    if (sessionId) {
      this.sessionService.deleteSession(sessionId);
    }
  }
}


